module.exports = __webpack_public_path__ + "img/logo5.1eaa01e7.png";